import { cn } from '@/lib/cn';
import { type JSX, Show } from 'solid-js';

export interface EmptyStateProps {
  title: string;
  body?: string;
  action?: JSX.Element;
  variant?: 'default' | 'error';
  class?: string;
}

export const EmptyState = (props: EmptyStateProps): JSX.Element => (
  <div
    class={cn(
      'flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed p-8 text-center',
      props.variant === 'error'
        ? 'border-red-300 dark:border-red-700'
        : 'border-neutral-300 dark:border-neutral-700',
      props.class,
    )}
  >
    <h3 class="text-base font-semibold text-neutral-900 dark:text-neutral-100">{props.title}</h3>
    <Show when={props.body}>
      <p class="max-w-sm text-sm text-neutral-500 dark:text-neutral-400">{props.body}</p>
    </Show>
    <Show when={props.action}>
      <div class="mt-2">{props.action}</div>
    </Show>
  </div>
);
